import type { RootState } from 'src/redux/store';

// The whole Rate Engine V2 switch, not an agency-contracts one: the API refuses every endpoint in
// this feature when it is off. It says which UI exists, never which world a given contract is in.
export const isPricingV2Enabled = (state: RootState): boolean =>
  Boolean(state.StartAppSettings?.feature_flags?.pricing_configuration_enabled);

export const isLegalEntityEnabled = (state: RootState): boolean =>
  Boolean(state.StartAppSettings?.feature_flags?.legal_entity_enabled);

// The organisation's pension feature; gates whether the contract's under-21 setting is offered and shown.
export const isPensionOptOutEnabled = (state: RootState): boolean =>
  Boolean(state.StartAppSettings?.feature_flags?.pension_opt_out_enabled);
